const SET_EXTRA = 'mrDistribution/SET_EXTRA';
const SET_EXTRAS = 'mrDistribution/SET_EXTRAS';

export default {
  // CHANGE_VALUES,

  SET_EXTRA,
  SET_EXTRAS,
};
